// Botón «Compartir» de los artículos y notas (blog y Actualidad). Cada entrada es [es, en, pt-BR].
export const articleMessages = Object.fromEntries(
  [
    ['Compartir', 'Share', 'Compartilhar'],
    ['Copiar enlace', 'Copy link', 'Copiar link'],
    ['Compartir en X', 'Share on X', 'Compartilhar no X'],
    ['Compartir en Bluesky', 'Share on Bluesky', 'Compartilhar no Bluesky'],
    ['Compartir en LinkedIn', 'Share on LinkedIn', 'Compartilhar no LinkedIn'],
    ['Enlace copiado', 'Link copied', 'Link copiado'],
  ].map(([es, en, pt]) => [es, [en, pt]])
);
